import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Зээлийн жагсаалт ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Зээлийн мэдээлэл")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "card shadow" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "fas fa-money-bill fs-5 me-3",
      style: {"color":"black"}
    }),
    /*#__PURE__*/_createElementVNode("b", null, "Төлөлтийн мэдээлэл")
  ])
], -1)
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "row g-10" }
const _hoisted_11 = { class: "col-lg-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", {
  class: "card-title",
  style: {"font-weight":"600"}
}, " Зээлийн төлөлтийн график ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-plus fs-5 me-3",
  style: {"color":"white"}
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Нэмэх ")
const _hoisted_16 = { class: "col-lg-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", {
  class: "card-title",
  style: {"font-weight":"600"}
}, "Зээлийн төлөлт", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-plus fs-5 me-3",
  style: {"color":"white"}
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Нэмэх ")
const _hoisted_21 = { class: "col-lg-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", {
  class: "card-title",
  style: {"font-weight":"600"}
}, " Хүүгийн төлөлтийн график ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-plus fs-5 me-3",
  style: {"color":"white"}
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Нэмэх ")
const _hoisted_26 = { class: "col-lg-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", {
  class: "card-title",
  style: {"font-weight":"600"}
}, "Хүүгийн төлөлт", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-plus fs-5 me-3",
  style: {"color":"white"}
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Нэмэх ")
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = { class: "card shadow" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "fas fa-users fs-5 me-3",
      style: {"color":"black"}
    }),
    /*#__PURE__*/_createElementVNode("b", null, "Хамтран зээлдэгч")
  ])
], -1)
const _hoisted_35 = { class: "card-body" }
const _hoisted_36 = { class: "row g-10" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h6", null, "Холбогдох иргэний мэдээлэл", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-plus fs-5 me-3",
  style: {"color":"white"}
}, null, -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Нэмэх ")
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h6", null, "Холбогдох байгууллагын мэдээлэл", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-plus fs-5 me-3",
  style: {"color":"white"}
}, null, -1)
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Нэмэх ")
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = { class: "card shadow" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "fas fa-building fs-5 me-3",
      style: {"color":"black"}
    }),
    /*#__PURE__*/_createElementVNode("b", null, "Барьцаа хөрөнгийн мэдээлэл")
  ])
], -1)
const _hoisted_49 = { class: "card-body" }
const _hoisted_50 = { class: "row g-10" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-plus fs-5 me-3",
  style: {"color":"white"}
}, null, -1)
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Нэмэх ")
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_loan_details_payment = _resolveComponent("loan-details-payment")!
  const _component_loan_details_relation = _resolveComponent("loan-details-relation")!
  const _component_loan_details_mort = _resolveComponent("loan-details-mort")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/loan/list' } }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_alert, {
      description: this.version,
      title: "Санамж!",
      type: "warning"
    }, null, 8, ["description"]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: this.loanDetails,
              border: "",
              size: "mini",
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна.",
              "cell-style": { textAlign: 'center' },
              "header-cell-style": { textAlign: 'center' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "#",
                  width: "40px"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Төлөгдөх огноо",
                  prop: "datetopay",
                  formatter: _ctx.$filters.formatDateYMD
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Төлөгдөх дүн",
                  prop: "amounttopay",
                  formatter: _ctx.$filters.formatPrice
                }, null, 8, ["formatter"])
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, this.dataLoading]
            ]),
            _hoisted_13,
            _createVNode(_component_el_button, {
              size: "mini",
              type: "primary",
              "data-bs-target": "#loanPayGraph",
              "data-bs-toggle": "modal"
            }, {
              default: _withCtx(() => [
                _hoisted_14,
                _hoisted_15
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: this.loanPerformance,
              border: "",
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна.",
              size: "mini",
              "cell-style": { textAlign: 'center' },
              "header-cell-style": { textAlign: 'center' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "#",
                  width: "40px"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Төлөгдөх огноо",
                  formatter: _ctx.$filters.formatDateYMD,
                  prop: "paiddate"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Төлөгдөх дүн",
                  formatter: _ctx.$filters.formatPrice,
                  prop: "paidamount"
                }, null, 8, ["formatter"])
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, this.dataLoading]
            ]),
            _hoisted_18,
            _createVNode(_component_el_button, {
              size: "mini",
              type: "primary",
              "data-bs-target": "#loanPay",
              "data-bs-toggle": "modal"
            }, {
              default: _withCtx(() => [
                _hoisted_19,
                _hoisted_20
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: this.interestDetails,
              border: "",
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна.",
              size: "mini",
              "cell-style": { textAlign: 'center' },
              "header-cell-style": { textAlign: 'center' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "#",
                  width: "40px"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Төлөгдөх огноо",
                  prop: "datetopay",
                  formatter: _ctx.$filters.formatDateYMD
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Төлөгдөх дүн",
                  prop: "amounttopay",
                  formatter: _ctx.$filters.formatPrice
                }, null, 8, ["formatter"])
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, this.dataLoading]
            ]),
            _hoisted_23,
            _createVNode(_component_el_button, {
              size: "mini",
              type: "primary",
              "data-bs-target": "#interestPayGraph",
              "data-bs-toggle": "modal"
            }, {
              default: _withCtx(() => [
                _hoisted_24,
                _hoisted_25
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: this.interestPerformance,
              border: "",
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна.",
              size: "mini",
              "cell-style": { textAlign: 'center' },
              "header-cell-style": { textAlign: 'center' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "#",
                  width: "40px"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Төлөгдөх огноо",
                  formatter: _ctx.$filters.formatDateYMD,
                  prop: "paiddate"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Төлөгдөх дүн",
                  formatter: _ctx.$filters.formatPrice,
                  prop: "paidamount"
                }, null, 8, ["formatter"])
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, this.dataLoading]
            ]),
            _hoisted_28,
            _createVNode(_component_el_button, {
              size: "mini",
              type: "primary",
              "data-bs-target": "#interestPay",
              "data-bs-toggle": "modal"
            }, {
              default: _withCtx(() => [
                _hoisted_29,
                _hoisted_30
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_31
      ])
    ]),
    _hoisted_32,
    _createElementVNode("div", _hoisted_33, [
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", null, [
            _hoisted_37,
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: this.customerRelationCitizen,
              border: "",
              "element-loading-text": "Өгөгдөл татаж байна...",
              size: "mini",
              "empty-text": "Өгөгдөл байхгүй байна.",
              "cell-style": { textAlign: 'center' },
              "header-cell-style": { textAlign: 'center' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "#",
                  width: "40px"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Холбогдогчийн регистерийн №",
                  prop: "registerno"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Холбогдогчийн овог",
                  prop: "lastname"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Холбогдогчийн нэр",
                  prop: "subjectname"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Үндсэн зээлдэгчийн код",
                  prop: "customercode"
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, this.dataLoading]
            ]),
            _hoisted_38,
            _createVNode(_component_el_button, {
              size: "mini",
              type: "primary",
              "data-bs-target": "#relationCitizenModal",
              "data-bs-toggle": "modal"
            }, {
              default: _withCtx(() => [
                _hoisted_39,
                _hoisted_40
              ]),
              _: 1
            })
          ]),
          _hoisted_41,
          _createElementVNode("div", null, [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: this.customerRelationOrg,
              border: "",
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна.",
              size: "mini",
              "cell-style": { textAlign: 'center' },
              "header-cell-style": { textAlign: 'center' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "#",
                  width: "40px"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Регистрийн дугаар",
                  prop: "registerno"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Холбогдох байгууллагын нэр",
                  prop: "subjectname"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Улсын бүртгэлийн дугаар",
                  prop: "stateregisterno"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Үндсэн зээлдэгчийн код",
                  prop: "customercode"
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, this.dataLoading]
            ]),
            _hoisted_42,
            _createVNode(_component_el_button, {
              size: "mini",
              type: "primary",
              "data-bs-target": "#relationOrgModal",
              "data-bs-toggle": "modal"
            }, {
              default: _withCtx(() => [
                _hoisted_43,
                _hoisted_44
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_45
      ])
    ]),
    _hoisted_46,
    _createElementVNode("div", _hoisted_47, [
      _hoisted_48,
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", null, [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: this.mortgage,
              border: "",
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна.",
              size: "mini",
              "cell-style": { textAlign: 'center' },
              "header-cell-style": { textAlign: 'center' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "#",
                  width: "40px"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Хөрөнгийн дугаар",
                  prop: "uniquenumber"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Барьцаа хөрөнгийн үндсэн төрөл",
                  prop: "mrtname"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Барьцаа хөрөнгийн дэд төрөл",
                  prop: "submrtname"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Үнэлгээ хийсэн огноо",
                  prop: "dateofvaluation",
                  formatter: _ctx.$filters.formatDateYMDHMS
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Барьцаа хөрөнгөөс барьцаалагчийн шаардлагыг хангаж болох дээд хязгаар",
                  prop: "limit",
                  formatter: _ctx.$filters.formatPrice
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Барьцаа хөрөнгийн үнэлгээ",
                  prop: "mrtvalue",
                  formatter: _ctx.$filters.formatPrice
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Валют",
                  width: "80px",
                  prop: "currency"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Барьцааг эзэмшигчийн улсын бүртгэлийн №",
                  prop: "stateregisterno"
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, this.dataLoading]
            ]),
            _hoisted_51,
            _createVNode(_component_el_button, {
              size: "mini",
              type: "primary",
              "data-bs-target": "#mortModal",
              "data-bs-toggle": "modal"
            }, {
              default: _withCtx(() => [
                _hoisted_52,
                _hoisted_53
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_54
      ])
    ]),
    _createVNode(_component_loan_details_payment, {
      onReloadLoanDetails: _ctx.getLoanDetails,
      title: "Зээлийн төлөлтийн график",
      type: "loanPayGraph",
      loancode: this.loancode
    }, null, 8, ["onReloadLoanDetails", "loancode"]),
    _createVNode(_component_loan_details_payment, {
      onReloadLoanDetails: _ctx.getLoanDetails,
      title: "Зээлийн төлөлт",
      type: "loanPay",
      loancode: this.loancode
    }, null, 8, ["onReloadLoanDetails", "loancode"]),
    _createVNode(_component_loan_details_payment, {
      onReloadLoanDetails: _ctx.getLoanDetails,
      title: "Хүүгийн төлөлтийн график",
      type: "interestPayGraph",
      loancode: this.loancode
    }, null, 8, ["onReloadLoanDetails", "loancode"]),
    _createVNode(_component_loan_details_payment, {
      onReloadLoanDetails: _ctx.getLoanDetails,
      title: "Хүүгийн төлөлт",
      type: "interestPay",
      loancode: this.loancode
    }, null, 8, ["onReloadLoanDetails", "loancode"]),
    _createVNode(_component_loan_details_relation, {
      onReloadLoanDetails: _ctx.getLoanDetails,
      loancode: this.loancode,
      customercode: this.customercode
    }, null, 8, ["onReloadLoanDetails", "loancode", "customercode"]),
    _createVNode(_component_loan_details_mort, {
      onReloadLoanDetails: _ctx.getLoanDetails,
      loancode: this.loancode,
      customercode: this.customercode,
      mrtType1: this.mrtType1,
      mrtType2: this.mrtType2,
      currencies: this.currencies,
      transferReason: this.transferReason,
      authImmovable: this.authImmovable
    }, null, 8, ["onReloadLoanDetails", "loancode", "customercode", "mrtType1", "mrtType2", "currencies", "transferReason", "authImmovable"])
  ], 64))
}